export class Track {

    name: string;
    code: string;

    constructor(track: ITrack) {

        this.name = track.name;
        this.code = track.code;
    }
}

export interface ITrack {

    name: string;
    code: string;
}